// Elastic APM RUM initialization (side-effect module)
// Keep this as the very first import in the app entry (index.tsx)
import { init as initApm } from '@elastic/apm-rum';

const apm = initApm({
  serviceName: process.env.REACT_APP_APM_SERVICE_NAME || 'OSCAR-frontend',
  serverUrl:
    process.env.REACT_APP_APM_SERVER_URL || 'https://prd.apm.petronas.com',
  environment:
    process.env.REACT_APP_APM_ENV || process.env.NODE_ENV || 'development',
  distributedTracingOrigins: (
    process.env.REACT_APP_APM_DT_ORIGINS || 'https://oscar.petronas.com'
  )
    .split(',')
    .map(o => o.trim())
    .filter(Boolean),
  propagateTracestate: true,
});

apm.addLabels({
  adoid: process.env.REACT_APP_APM_ADO_ID || 'UNKNOWN',
  pn: process.env.REACT_APP_APM_PRODUCT_NAME || 'OSCAR',
  bs: process.env.REACT_APP_APM_BUSINESS_SEGMENT || 'gne',
});

export default apm;
